var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"border-primary border-2 rounded-full flex w-8 h-8 items-center justify-center font-normal text-primary cursor-default",attrs:{"id":_vm.iconId}},[_vm._v("i")])])}
var staticRenderFns = []

export { render, staticRenderFns }